export const LEAK_ALARM_POLL_MS = 60 * 1000;
